import { graphql, Link, useStaticQuery } from "gatsby";
import React from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";
import Img from "gatsby-image";
import FruitIcon from "../FruitIcon";
import Pepper from "../../imageComponents/fruits/default/pepper";
import PepperSwooshes from "../../imageComponents/fruits/swooshes/pepper_swooshes";
import Corn from "../../imageComponents/fruits/default/corn";
import Carrots from "../../imageComponents/fruits/default/carrots";
import Marrons from "../../imageComponents/fruits/default/marrons";
import Lemon from "../../imageComponents/fruits/default/lemon";
import LemonSwooshes from "../../imageComponents/fruits/swooshes/lemon_swooshes";

const imagesQuery = graphql`
  query {
    foodPanda: file(relativePath: { eq: "food_panda.png" }) {
      childImageSharp {
        fixed(width: 247, height: 91) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    pedidosYa: file(relativePath: { eq: "pedidos_ya.png" }) {
      childImageSharp {
        fixed(width: 247, height: 91) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`;

const PreFooter = () => {
  const { t } = useTranslation();
  const result = useStaticQuery(imagesQuery);
  const { foodPanda = {}, pedidosYa = {} } = result;
  return (
    <div className="pre-footer layout desktop:container-desktop mobile:container-mobile tablet:container-mobile">
      <div className="divider"></div>
      <div className="content">
        <h2 className="desktop:desktop-h2 tablet:mobile-h2 mobile:mobile-h2">
          {t("preFooterContent")}
        </h2>
        <div className="logos">
          <Link to={"https://www.foodpanda.com/"} target={"_blank"}>
            <Img fixed={foodPanda?.childImageSharp?.fixed} />
          </Link>
          <Link to={"https://www.pedidosya.com/"} target={"_blank"}>
            <Img fixed={pedidosYa?.childImageSharp?.fixed} />
          </Link>
        </div>
      </div>
      <div className="fruits">
        <FruitIcon
          className="pepper-icon fruit"
          Icon={Pepper}
          withSwoosh={true}
          swooshColor={"white"}
          iconColor={"white"}
          Swoosh={PepperSwooshes}
        />
        <FruitIcon
          className="corn-icon fruit"
          Icon={Corn}
          withSwoosh={false}
          iconColor={"white"}
        />
        <FruitIcon
          className="carrot-icon fruit"
          Icon={Carrots}
          withSwoosh={false}
          iconColor={"white"}
        />
        <FruitIcon
          className="marron-icon fruit"
          Icon={Marrons}
          withSwoosh={false}
          iconColor={"white"}
        />
        <FruitIcon
          className="lemon-icon fruit"
          Icon={Lemon}
          withSwoosh={true}
          swooshColor={"white"}
          iconColor={"white"}
          Swoosh={LemonSwooshes}
        />
      </div>
    </div>
  );
};

export default PreFooter;
